// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media print {\n  .MuiDialog-root .MuiDialog-paperScrollBody {\n    display: block;\n  }\n}\n", "",{"version":3,"sources":["webpack://../../node_modules/@visma/formula/lib/styles.css"],"names":[],"mappings":"AAAA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["@media print {\n  .MuiDialog-root .MuiDialog-paperScrollBody {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
